import request from "./request";
import { stringify } from "qs";
import UrlConfig from "./apiConfig";
export const BaseUrl = UrlConfig.REQUEST_URL;
export const BaseUrlA2pApi =
  UrlConfig.EVN_CONFIG === "dev"
    ? "http://10.45.50.230:8321"
    : UrlConfig.checkVerifyCodeUrl || "";
const protocol = location.protocol;
const webSocketProtocol = protocol === "https:" ? "wss:" : "ws:";
export const WebSocketUrl = webSocketProtocol + UrlConfig.WEBSOCKET_URL;
// const BaseUrl = 'http://10.45.50.230:8007' // 开发环境
// const SMSCodeUrl = 'http://10.45.50.59:8041'
// export const WebSocketUrl = 'ws://10.45.50.59:8058/a2papi/message_push/v1/quickAppMessage/'

// const BaseUrl = 'https://api.5gomsg.com' // 阿里云环境
// const protocol = location.protocol
// const webSocketProtocol = protocol === 'https:' ? 'wss:' : 'ws:'
// export const WebSocketUrl = webSocketProtocol + '//hetu.5gomsg.com/a2papi/message_push/v1/quickAppMessage/'

// 根据templateCode 获取号码和servicesNo
export async function createFictitiousPhone(params) {
  return request({
    url:
      BaseUrl +
      `/a2p/api/v1/quickapp/createFictitiousPhone?${stringify(params)}`,
    method: "GET"
  });
}

// 上行消息回执
export async function receiveReport(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/quickapp/receiveReport",
    method: "POST",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

// 上报设备信息
export async function submitPhoneInfo(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/submitPhoneInfo",
    method: "POST",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

// 根据号码查询关注的机器人
export async function queryCareChatbot(mobileNo) {
  return request({
    url: BaseUrl + "/a2p/api/v1/careChatbot/selectList?mobileNo=" + mobileNo,
    method: "GET"
  });
}

// 添加关注机器人
export async function addCareChatbot(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/careChatbot/add",
    method: "POST",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

// 取消关注
export async function cancelCareChatbot(careChatbotCode) {
  return request({
    url:
      BaseUrl +
      "/a2p/api/v1/careChatbot/cancel?careChatbotCode=" +
      careChatbotCode,
    method: "DELETE"
  });
}

// 获取短信验证码
export async function getSmsCode(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/verify/code/getSmsCode?" + stringify(params),
    method: "get"
  });
}

// 验证短信验证码
export async function checkSmsCode(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/verify/code/checkSmsCode?" + stringify(params),
    method: "get"
  });
}

// 查询机器人列表
export async function queryChatbotList(mobileNo) {
  return request({
    url:
      BaseUrl +
      "/a2p/api/v1/maapConfig/selectMaapListWithQuickApp?" +
      stringify({ phone: mobileNo, terminal: "H5" }),
    method: "get"
  });
}

// 查询机器人静态菜单
export async function queryMenuByServiceNo(params, apiUrl) {
  const domainUrl = apiUrl || BaseUrl;
  return request({
    url:
      domainUrl +
      "/a2p/api/v1/maapConfig/selectMenuByServiceNo?" +
      stringify(params),
    method: "GET"
  });
}

// 查询机器人详情
export async function queryChatbotByServiceNo(params, apiUrl) {
  const domainUrl = apiUrl || BaseUrl;
  return request({
    url:
      domainUrl +
      "/a2p/api/v1/maapConfig/selectMaapByServiceNoAndPhone?" +
      stringify(params),
    method: "GET"
  });
}

// 上行消息
export async function upMessage(params, apiUrl) {
  const domainUrl = apiUrl || BaseUrl;
  return request({
    url: domainUrl + "/a2p/api/v1/quickapp/receive",
    method: "post",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

// 上传文件
export const uploadFileUrl = "/a2p/api/v1/file/quickapp/upload";

// base64解码
export async function decode64(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/quickapp/decode",
    method: "post",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

// base64编码
export async function encode64(params) {
  return request({
    url: BaseUrl + "/a2p/api/v1/quickapp/encode",
    method: "post",
    data: params,
    headers: { "Content-Type": "application/json" }
  });
}

export async function checkVerifyCode(params) {
  return request({
    url:
      BaseUrlA2pApi +
      `/a2papi/hetuportal/v1/user/checkVerifyCode?${stringify(params)}`
  });
}



// WEBPACK FOOTER //
// ./src/services.js